$("#pd_video").click(function(){
  $("#pd_video").addClass("pf_videoactive");
}); 


function show(){ 
	var box = document.getElementById("show_product_info"); 
	var text = box.innerHTML; 
	var newBox = document.createElement("div"); 
	var btn = document.createElement("a"); 
	newBox.innerHTML = text.substring(0,600); 
	btn.innerHTML = text.length > 600 ? "<i class=\"fa fa-angle-double-down\"></i>See More" : ""; 
	btn.href = "###"; 
	btn.onclick = function(){ 
		if (btn.innerHTML == "<i class=\"fa fa-angle-double-down\"></i>See More"){ 
			btn.innerHTML = "<i class=\"fa fa-angle-double-up\"></i>Back"; 
          	$('.show_product_info_content').parent().css('overflow','unset');
			newBox.innerHTML = text; 
		}else{ 
			btn.innerHTML = "<i class=\"fa fa-angle-double-down\"></i>See More"; 
          	$('.show_product_info_content').parent().css('overflow','unset');
			newBox.innerHTML = text.substring(0,600); 
		} 
	} 
	box.innerHTML = ""; 
	box.appendChild(newBox); 
	box.appendChild(btn); 
} 
show(); 

$(function(){
    var win=$(window); 
    var sc=$(document);
    win.scroll(function(){
          if(sc.scrollTop()>180){
              	$('.top_buy_now').show();
          }else{
              	$('.top_buy_now').hide();
          }
          if(sc.scrollTop()>=90){
        		$("#search_box").addClass("pd_sticky"); 
              	$(".stick_bottom").addClass("stick_bottom_show"); 
          }else{
                $("#search_box").removeClass("pd_sticky");
              	$(".stick_bottom").removeClass("stick_bottom_show");
          }
    })
})

function ismobile() {
    var mobileArry = ["iPhone", "iPad", "Android", "Windows Phone", "BB10; Touch", "BB10; Touch", "PlayBook", "Nokia"];
    var ua = navigator.userAgent;
    var res=mobileArry.filter(function(arr) {
        return ua.indexOf(arr) > 0;
    });
    return res.length > 0;

}
	function show_choice_box(){
	$('#zz').toggle();
  $('.select_choice').toggle();
}
  
  function submitBuy(){
  	$('#addToCartForm').submit();
  }
 
